import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function AccountIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("w-6 h-6", className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7113 17.2168C19.8323 15.7767 20.5 13.9663 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 13.9663 4.16769 15.7767 5.28871 17.2168C6.148 15.3567 8.82754 14 12 14C15.1725 14 17.852 15.3567 18.7113 17.2168ZM17.4999 18.4811C17.4919 17.9247 17.134 17.2197 16.1386 16.5798C15.148 15.9429 13.6889 15.5 12 15.5C10.3111 15.5 8.85203 15.9429 7.86139 16.5798C6.86603 17.2197 6.50806 17.9247 6.50014 18.4811C7.98256 19.7403 9.90256 20.5 12 20.5C14.0974 20.5 16.0174 19.7403 17.4999 18.4811ZM5.09168 19.2302C3.18663 17.4094 2 14.8433 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.8433 20.8134 17.4094 18.9083 19.2302C17.113 20.9461 14.6796 22 12 22C9.58375 22 7.36766 21.143 5.63907 19.7165C5.45069 19.561 5.26811 19.3988 5.09168 19.2302ZM12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5ZM12 13C14.2091 13 16 11.2091 16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13Z"
        fill="currentColor"
      />
    </svg>
  );
}
